import connect from 'react-redux/es/connect/connect';
import * as foldersActions from '../../../actions/Folders';
import * as formatsActions from '../../../actions/Formats';
import Formats from '../components/Formats';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        folders: state.folders.formatFolders,
        formats: state.formats.folderFormats,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getFolders: (type) => {
            dispatch(foldersActions.getFormatFolders(type));
        },
        clearFolders: () => {
            dispatch(foldersActions.clearFormatFolders());
        },
        getFormats: (type, folderId) => {
            dispatch(formatsActions.getFolderFormats(type, { folderId }));
        },
        clearFormats: () => {
            dispatch(formatsActions.clearFolderFormats());
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Formats);

